/**
 * graph001-002
 */
export default class {

	constructor(id, data, size) {
		this.ID = id;
		this.DATA = data;
		this.SIZE = size;
		this.TOTAL = data ? d3.sum(data) : 0;
		this.WIDTH = 400;
		this.HEIGHT = 400;

		// percent cricle progress
		this.PER = !this.TOTAL ? 0 : (data[0] - data[2]) * -1 / this.TOTAL;

		// objects
		this.svg;
		this.meter;
		this.txtTotalForm;
		this.percentComplete;
		this.foreground;

		// init
		this.graph();
	}

	graph() {
		// check
		if(!$(this.ID).length) return false;

		// architect
		var arch = this.arch();

		// svg
		this.svg = this.drawSvg(arch);

		// circle
		this.drawCircle(arch);

		// text contents
		this.addTextContents();

		// bar
		this.drawBar(15);

		// fixed style
		$(this.ID).find(".foreground").removeClass("negative");
		if(this.PER < 0) $(this.ID).find(".foreground").addClass("negative");

		// progress
		this.finProgress(arch);

		return false;
	}

	arch() {
		// normal
		if(!this.SIZE) {
			return {
				border: d3.arc().innerRadius(170).outerRadius(168).startAngle(0).endAngle(90),
				wrArc: d3.arc().innerRadius(200).outerRadius(188).startAngle(0).endAngle(90),
				arc: d3.arc().startAngle(0).innerRadius(185).outerRadius(175),
				sizeGraph: "93%"
			};
		}

		// small
		return {
			border: d3.arc().innerRadius(170).outerRadius(169).startAngle(0).endAngle(90),
			wrArc: d3.arc().innerRadius(200).outerRadius(190).startAngle(0).endAngle(90),
			arc: d3.arc().startAngle(0).innerRadius(185).outerRadius(177),
			sizeGraph: "91%"
		};
	}

	drawSvg(arch) {
		return d3.select(this.ID).append("svg")
			.attr("width", arch.sizeGraph)
			.attr("height", arch.sizeGraph)
			.attr('viewBox','0 0 ' + Math.min(this.WIDTH, this.HEIGHT)  + ' ' + Math.min(this.WIDTH, this.HEIGHT))
			.attr('preserveAspectRatio', 'xMinYMin')
			.append("g")
			.attr("transform", "translate(" + Math.min(this.WIDTH, this.HEIGHT) / 2 + "," + Math.min(this.WIDTH, this.HEIGHT) / 2 + ")");
	}

	drawCircle(arch) {
		this.meter = this.svg.append("g").attr("class", "c-" + this.ID);
		this.meter.append("path").attr("d", arch.wrArc).attr("class", "tick-bg");
		this.meter.append("path").attr("d", arch.border).attr("class", "border");
		this.meter.append("path").attr("class", "background").attr("d", arch.arc.endAngle(2 * Math.PI));

		this.foreground = this.meter.append("path").attr("class", "foreground");

		if(this.SIZE) {
			// small
			this.svg.selectAll("path.tick")
				.data(d3.range(360))
				.enter()
				.append("path")
				.classed("tick", true)
				.attr("stroke", "#737373")
				.attr("d", d => {
					let s = d % 18 ? 0 : 10;
					d = d / 180 * Math.PI;
					let x = Math.cos(d);
					let y = Math.sin(d);
					let r = 200;
					return `M${x * r},${y * r}L${x * (r - s)},${y * (r - s)}`;
				});
			return;
		}

		// normal
		this.svg.selectAll("path.tick")
			.data(d3.range(360))
			.enter()
			.append("path")
			.classed("tick", true)
			.attr("stroke", "#B0AEAD")
			.attr("d", d => {
				let s = d % 9 ? 0 : 10;
				d = d / 180 * Math.PI;
				let x = Math.cos(d);
				let y = Math.sin(d);
				let r = 200;
				return `M${x * r},${y * r}L${x * (r - s)},${y * (r - s)}`;
		});

		this.svg.selectAll("path.tick2")
			.data(d3.range(360))
			.enter()
			.append("path")
			.classed("tick2", true)
			.attr("stroke", "#707070")
			.attr("stroke-opacity", 0.6)
			.attr("d", d => {
				let s = d % 18 ? 0 : 10;
				d = d / 180 * Math.PI ;
				let x = Math.cos(d);
				let y = Math.sin(d);
				let r = 200;
				return `M${x * r},${y * r}L${x * (r - s)},${y * (r - s)}`;
			});
	}

	addTextContents() {
		var posTopNPS, posTopPerComple, posTopNumAnswers, posTopNumTotal;
		if(!this.SIZE) {
			posTopNPS = "-5.6em";
			posTopPerComple = "-0.7em";
			posTopNumAnswers = "2.7em";
			posTopNumTotal = "2.23em";
		} else {
			posTopNPS = "-4.9em";
			posTopPerComple = "-1em";
			posTopNumAnswers = "2.4em";
			posTopNumTotal = "2.4em";
		}

		// NPS Score
		var textNPS = this.PER > 0 ? "NPS" : "NPSスコア";
		this.meter.append("text")
			.attr("text-anchor", "middle")
			.attr("class", "description")
			.attr("dy", posTopNPS)
			.attr("fill", "#707070")
			.text(textNPS);

		// 回答数
		this.meter.append("text")
			.attr("text-anchor", "middle")
			.attr("class", "description")
			.attr("dy", posTopNumAnswers)
			.attr("fill", "#707070")
			.text("回答数");

		// Total
		this.txtTotalForm = this.meter.append("text")
			.attr("text-anchor", "middle")
			.attr("class", "percent-complete number-total")
			.attr("dy", posTopNumTotal)
			.attr("fill", "#383F41")
			.text(this.TOTAL);

		// Percent
		this.percentComplete = this.meter.append("text")
			.attr("text-anchor", "middle")
			.attr("class", "percent-complete")
			.attr("fill", "#383F41")
			.attr("dy", posTopPerComple);

		// count up
		$(this.ID).find(".number-total").prop("Counter", 0).animate(
			{Counter: this.TOTAL},
			{
				duration: 1000,
				easing: "swing",
				step: function (now) { $(this).text(Math.ceil(now)); }
			}
		);
	}

	drawBar(heightR) {
		var accuPerc = 0;

		var svgBar = this.svg.append("svg")
			.attr("width", 338)
			.attr("height", heightR)
			.attr("class", "c-graph--bar")
			.append("g")
			.attr("transform", "translate(-170, -7)");

		var bar = svgBar.selectAll("g")
			.data(this.DATA)
			.enter().append("g");

		bar.append("rect")
			.attr("width", function (d) {
				return d == 0 ? "0%" : (d / this.TOTAL * 100) + "%";
			}.bind(this))
			.attr("x", function (d) {
				if(!d) return "0%";

				let prevPerc = accuPerc;
				let currPerc = 100 * (d / this.TOTAL);
				accuPerc = accuPerc + currPerc;
				return prevPerc + "%";
			}.bind(this))
			.attr("height", heightR)
			.attr("class", function (d, i) { return "rect" + i });
	}

	finProgress(arch) {
		var formatPercent = d3.format(".1f");

		var progress = 0;
		var i = d3.interpolate(progress, this.PER);

		d3.select("body").selectAll(this.ID).transition().duration(1000).tween("progress", function () {
			return function (t) {
				progress = i(t);
				this.foreground.attr("d", arch.arc.endAngle(2 * Math.PI * progress));
				this.percentComplete.text(formatPercent(progress * 100));
				this.txtTotalForm.text(this.TOTAL);
			}.bind(this)
		}.bind(this));
	}
}
